module.exports = __webpack_public_path__ + "static/img/gf1.4f1c833.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/gf1.png
// module id = byEU
// module chunks = 1